import { map } from "nanostores"

interface Place {
  street: string
  fullAddress: string
  placeId: string
}

export const place: () => Place | null = () =>
  analysisDataStore.get().place || null

interface AnalysisDataState {
  place?: Place | null
}

// Create a map store with the initial state
export const analysisDataStore = map<AnalysisDataState>({
  place: null,
})

// Actions to update the store
// Make sure to validate or cast the inputs appropriately before calling these functions

export const updatePlace = (place: Place) => {
  analysisDataStore.set({
    ...analysisDataStore.get(),
    place,
  })
}
